import { useMemo } from "react";
import "./Item.css";

const Item = ({
  heading4SecurityMeasures,
  muhammadAbdullah,
  s03svg,
  propTop,
}) => {
  const before1Style = useMemo(() => {
    return {
      top: propTop,
    };
  }, [propTop]);

  return (
    <div className="item23">
      <div className="divicon7">
        <div className="security-icon-frame1">
          <div className="circle" />
        </div>
      </div>
      <div className="divcollgmargin">
        <div className="heading-43">{heading4SecurityMeasures}</div>
        <div className="muhammad-abdullah">{muhammadAbdullah}</div>
      </div>
    </div>
  );
};

export default Item;
